import type { TourDefinition } from './types'

export const TRAINEE_WITH_COACH_TOUR_ID = 'traineeWithCoach'
export const TRAINEE_WITH_COACH_TOUR_VERSION = 3

/**
 * Additional tour when a trainee gets a coach assigned.
 * Independent of the solo tour — runs when hasCoaches becomes true and progress < version.
 */
export const TRAINEE_WITH_COACH_TOUR: TourDefinition = {
  id: TRAINEE_WITH_COACH_TOUR_ID,
  version: TRAINEE_WITH_COACH_TOUR_VERSION,
  copyKey: 'traineeWithCoach',
  hasWelcome: true,
  autoStart: ({ user }) => !!user && !user.hasTrainees && !!user.hasCoaches,
  steps: [
    {
      id: 'training-set',
      path: '/',
      target: 'tour-trainee-training-set',
      titleKey: 'setTitle',
      bodyKey: 'setBody',
      iconId: 'sets',
    },
    {
      id: 'more-with-coach',
      path: '/more',
      target: 'tour-more-with-coach',
      titleKey: 'withCoachTitle',
      bodyKey: 'withCoachBody',
      iconId: 'schedule',
    },
    {
      id: 'assistant',
      path: '/more',
      target: 'tour-more-assistant',
      titleKey: 'assistantTitle',
      bodyKey: 'assistantBody',
      iconId: 'assistant',
      tipPlacement: 'above',
    },
  ],
}
